import Vue from 'vue';
import noty from './noty.service';

export default {
  async getSettingsByClient(clientId) {
    return (await Vue.http.get(`/api/smartsoft/settings/byclient/${clientId}`)).data;
  },
  async save(clientId, galaxsysSettings) {
    await Vue.http.post(`/api/smartsoft/settings/byclient/${clientId}`, galaxsysSettings);
    noty.success('Settings saved successfully');
  }
}



// WEBPACK FOOTER //
// ./src/services/smartsoft.service.js